var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPorygonBg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 419.44 330.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#363636;}.cls-3{fill:#949494;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.45 119.52 154.29 198.32 98.31 187.75 162.45 119.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "67.45 161.82 83.4 194.58 51.29 207.73 67.45 161.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.4 262.21 223.98 245.92 237.47 277.89 191.4 262.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.78 231.99 36.35 258.47 17.13 239 58.78 231.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "162.45 318.56 116.28 246.8 177.33 170.62 162.45 318.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "249.75 121.15 260.67 205.78 172.83 248.4 249.75 121.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "34.25 275.25 26.32 293.8 0 281.11 34.25 275.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.85 318.56 41.01 330.57 40.18 314.28 56.85 318.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "58.94 296.09 66.04 284.41 85.33 282.9 58.94 296.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "75.74 302.06 80.15 319.86 64.63 311.71 75.74 302.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.15 208.03 97.53 215.35 86.18 245.23 80.15 208.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "54.1 144.11 83.48 119.52 126.49 134.81 54.1 144.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "216.61 212.48 217.24 150.24 249.45 149.46 216.61 212.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "194 114.66 199.92 151.79 160.67 151.1 194 114.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "130.38 31.96 163.22 31.29 167.76 66.08 130.38 31.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "151.79 173.63 133.14 178.3 129.99 149.46 151.79 173.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "158.82 60.88 201.76 108.57 164.48 134.42 158.82 60.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "157.03 186.17 171.2 191.69 156.35 219.7 157.03 186.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "126.18 189.51 122.66 209.93 94.07 204.94 126.18 189.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "268.26 114.11 253.51 141.35 216.75 114.68 268.26 114.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "262.01 236.73 229.45 221.11 294.56 213.29 262.01 236.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "189.39 232.51 187.57 218.75 198.35 217.51 189.39 232.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "201.76 165.46 223.02 62.76 288.63 68.91 201.76 165.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.94 166.4 100.73 85.56 158.17 75.91 98.94 166.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "95.23 42.13 117.82 68.55 85.33 95.49 95.23 42.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "146.65 164.4 191.15 153.1 205.45 188.13 146.65 164.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "287.32 210.66 236.69 199.63 256.73 155.19 287.32 210.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "173.31 208.32 185.89 186.17 212.61 199.86 173.31 208.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "121.7 296.09 103.96 280.95 134.41 280.95 121.7 296.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "98.04 256.56 101.8 247.49 117.97 255.02 98.04 256.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "159.97 272 169.7 287.85 158.53 293.8 159.97 272"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "156.83 236.23 140.08 250.98 129.11 238.69 156.83 236.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "317.24 30.27 319.29 97.38 267.76 115.28 317.24 30.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "281.14 72.77 224.54 147.41 184.92 103.44 281.14 72.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "254.18 186.17 339.06 158.19 338.2 221.67 254.18 186.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "214.83 0 233.03 31.12 205.45 49.31 214.83 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "296.76 138.71 376.96 88.43 408.37 173.14 296.76 138.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "419.44 190.26 371.2 190.86 380.43 238.69 419.44 190.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "254.46 63.21 179.59 79.37 166.49 24.7 254.46 63.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "276.48 133.22 317.43 102.46 311.54 127.36 276.48 133.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "235.64 47.47 238.79 74.67 203.68 88.86 235.64 47.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "261.66 137.5 282.37 172.88 226.55 154.25 261.66 137.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorygonBg3);
export default __webpack_public_path__ + "static/media/porygon_bg_3.33b5d58feb3a982c12b87c1881ad494c.svg";
export { ForwardRef as ReactComponent };